import React from 'react'

const TriangleDown = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.3 28.3">
    <path d="M14.2 21.3L28.3 7.1H0z" />
  </svg>
)

export default TriangleDown
